import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IDescriptionField {
	changeDescription: (value: string) => void;
}

const DescriptionField: React.FC<IDescriptionField> = ({ changeDescription }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterDescription') }], [t]);

	return (
		<FormInput
			testId="DescriptionField"
			name="description"
			label="descriptionLabel"
			maxLength={250}
			onChange={changeDescription}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DescriptionField);
